/**
 * Application-wide constants
 */

// App information
export const APP_NAME = "React Starter Kit";
export const APP_VERSION = "0.0.2";

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: "auth_token",
  USER: "user_data",
  THEME: "app_theme",
};

// Theme options
export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
};

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;

// Timeouts
export const TOAST_DURATION = 5000; // 5 seconds
export const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
